import { handleJsonResponse, getFilterQuery, addSortingQuery, getXsrfToken } from "./api";
import config from '../config';
import { getUser } from '../auth';

export async function getJobs(filters, sorting, start, limit) {
  const user = getUser();
  const token = user?.access_token;
  var filterQuery = getFilterQuery(filters);
  
  if (filterQuery.length > 0){
    filterQuery = "filter=" + filterQuery;
  }
  filterQuery = addSortingQuery(filterQuery, sorting);

  const response = await fetch(`${config.API_URL}/jobs?${filterQuery}&start=${start}&limit=${limit}`,
  {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  
  return  handleJsonResponse(response);
}
  
export async function getJob(id, setErrorMessage) {
  
  const user = getUser();
  const token = user?.access_token;
  
  const fetchJobSummaryPath = `${config.API_URL}/jobs/${id}/tasks/summary`;
  const fetchJobPath = `${config.API_URL}/jobs/${id}`;

  const fetchJobDetails = [fetchJobSummaryPath, fetchJobPath];
  const [summaryResponse, jobResponse] = await Promise.all(fetchJobDetails.map(path => 
      fetch(path, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    ));
    
    const summaryData = await handleJsonResponse(summaryResponse);    
    const jobData = await handleJsonResponse(jobResponse);
    jobData.taskSummary = summaryData;
    
    return jobData;
  
}

export async function getJobFiles(id, type, filtering, sorting, start = 0, limit = 10) {
  const user = getUser();
  const token = user?.access_token;

  filtering['type'] = { filter: type, type: ':' };

  let filterQuery = getFilterQuery(filtering);

  if (filterQuery.length > 0)
  {
    filterQuery = "filter=" + filterQuery;
  }

  filterQuery = addSortingQuery(filterQuery, sorting);

  const response = await fetch(
    `${config.API_URL}/jobs/${id}/files?${filterQuery}start=${start}&limit=${limit}`,
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  );

  return handleJsonResponse(response);
}

export async function updateJobState(id, jobState){
    
  const user = getUser();
  const token = user?.access_token;
  const data = JSON.stringify({"type": jobState, "archive":  new Date()});
  
  const response = await fetch(`${config.API_URL}/jobs/${id}/actions`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'X-XSRF-TOKEN': getXsrfToken()
    },
    body: data,
  });

  return handleJsonResponse(response);

  
}


export async function downloadJobFiles(id) {
  const user = getUser(); 
  const token = user?.access_token;

  const response = await fetch(`${config.API_URL}/jobs/${id}/download`,
  {
    headers: {
      responseType: 'blob',
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => response.blob())
  .then((blob) => {
    const fileUrl = window.URL.createObjectURL(blob);
    let alink = document.createElement('a');
    alink.href = fileUrl;
    alink.click();
  });

}

export async function copyJob(id){
  const user = getUser();
  const token = user?.access_token;
  
  const response = await fetch(`${config.API_URL}/jobs/${id}/copy`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'X-XSRF-TOKEN': getXsrfToken()
    },
  });

  return handleJsonResponse(response);
}

export async function getJobHistory(id, sorting, filtering, start = 0, limit = 10){
  const user = getUser();
  const token = user?.access_token;

  let filterQuery = getFilterQuery(filtering);

  if (filterQuery.length > 0){
    filterQuery = "filter=" + filterQuery + "&";
  }
  filterQuery = addSortingQuery(filterQuery, sorting);  
  
  const response = await fetch(`${config.API_URL}/jobs/${id}/history?${filterQuery}start=${start}&limit=${limit}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return handleJsonResponse(response);
}

export async function batchStateChange(state, jobs)
{
  const jobIds = jobs.map((job) => job.id);
  
  const user = getUser(); 
  const token = user?.access_token;
  
  const jobaction = {
    type: state,
    archive: new Date()
  }
  
  const responses = await Promise.all(jobs.map(async (job) => {
    try
    {
      const response = await fetch(`${config.API_URL}/jobs/${job.id}/actions`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          'X-XSRF-TOKEN': getXsrfToken()
        },
        body: JSON.stringify(jobaction),
      })
      const responseJson =  await handleJsonResponse(response)
      return {id: job.id, success: true, data: responseJson};
    }
    catch(error)
    {
      return {id: job.id, success: false, errorMessage: `${error.detail}`};
      
    }
  }));

  return responses;
}

export async function batchDownloadJobFiles(jobs) {
  const user = getUser(); 
  const token = user?.access_token;
  const jobIds = jobs.map((job) => job.id);
  
  const response = await fetch(`${config.API_URL}/jobs/batch-download`,
  {
    method: 'POST',
    headers :{
      responseType: 'blob',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-XSRF-TOKEN': getXsrfToken()
    },
    body: JSON.stringify(jobIds),
  })
  .then((response) => response.blob())
  .then((blob) => {
    const fileUrl = window.URL.createObjectURL(blob);
    let alink = document.createElement('a');
    alink.href = fileUrl;
    alink.click();
  });

}

export async function submitJob(jobDetails, selectedFiles, entryPointFileRow, outputPointFileRow) {

  try
  {
    const fileIds = selectedFiles.map((file) => file.id);
    const taskGenerationFile = entryPointFileRow.data;
    const taskOutputFile = outputPointFileRow.data;
    let newJob = {...jobDetails, 
                  files :fileIds,
                  resultGatheringEntryPoint :{fileId: taskOutputFile.id, method: 'output'},
                  taskExecutionEntryPoint :{fileId: taskOutputFile.id, method: 'output'},
                  taskGenerationEntryPoint :{fileId:  taskGenerationFile.id, method: 'init'},};
    
    
    const jsonJobDetails = JSON.stringify(newJob);

    const user = getUser();
    const token = user?.access_token;

    const response = await fetch(`${config.API_URL}/jobs/`, {
      method: 'POST',
  
      headers:
      {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': getXsrfToken()
      },
      code: 'cors', 
      body: jsonJobDetails,
    })
    return handleJsonResponse(response);

  }
  catch(error)
  {
    console.log(error)
  }
} 

export async function purgeJobs(jobIds){
  const user = getUser();
  const token = user?.access_token;

  try
  {
      const results = await Promise.all(jobIds.map(async (id) => {
        try{
          const response = await fetch(`${config.API_URL}/jobs/${id}`, {
          method: 'DELETE',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'X-XSRF-TOKEN': getXsrfToken()
          }
          });

          if(!response.ok)
          {
            const responseJson = await response.json();
            
            if(responseJson.detail)
            {
              return {id, success: false, error: responseJson.detail};
            }
            else if (responseJson.status === 404)
            {
              return {id, success: false, error: "Job Not Found"};
            }
            else
            {
              return {id, success: false, error: `Status Code: ${response.status}`};
            }
          }
          else
          {
            
            return {id, success: true};
          }
        }
        catch(error)
        {
          
          return { 
              id, 
              success: false, 
              error: error.message,

        }
      }
      }));
    return results;
  }
  catch(error)
  {
    console.log("Error purging jobs: ", error);
  }
  
}  


export async function purgeJob(id){
  const user = getUser();
  const token = user?.access_token;
  const response = await fetch(`${config.API_URL}/jobs/${id}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'X-XSRF-TOKEN': getXsrfToken()
    }
  });
  return handleJsonResponse(response);

}